import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { BoardColumn } from '../board-v3.types';

const LIGHT_LUMINANCE_THRESHOLD = 0.85;
const DARK_FALLBACK = '#374151';

@Component({
  selector: 'app-board-v3-column-header',
  templateUrl: './column-header.component.html',
  styleUrls: ['./column-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ColumnHeaderComponent {
  @Input({ required: true }) column!: BoardColumn;
  @Input() localCount: number = 0;
  @Input() selectionMode: boolean = false;
  @Input() allSelected: boolean = false;
  @Input() someSelected: boolean = false;

  @Output() onAdd = new EventEmitter<BoardColumn>();
  @Output() onMore = new EventEmitter<BoardColumn>();
  @Output() onClear = new EventEmitter<BoardColumn>();
  @Output() onSelectAll = new EventEmitter<BoardColumn>();

  get accentColor(): string {
    const bg = this.column.color.background;
    return this.isLight(bg) ? DARK_FALLBACK : bg;
  }

  get accentTextColor(): string {
    return this.isLight(this.column.color.background) ? '#ffffff' : this.column.color.text;
  }

  get systemTypeLabelKey(): string | null {
    if (this.column.type === 'SUCCESS') return 'board_v3_column_type_success';
    if (this.column.type === 'FAILED') return 'board_v3_column_type_failed';
    return null;
  }

  get systemTypeIcon(): string {
    return this.column.type === 'FAILED' ? 'cancel' : 'check_circle';
  }

  private isLight(hex: string): boolean {
    const h = hex.replace('#', '');
    if (h.length !== 6) return false;
    const r = parseInt(h.slice(0, 2), 16);
    const g = parseInt(h.slice(2, 4), 16);
    const b = parseInt(h.slice(4, 6), 16);
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance > LIGHT_LUMINANCE_THRESHOLD;
  }
}
